import "./App.css";
import { Link, Route, Routes } from "react-router-dom";
import Nav from "./component/nav/Nav";
import Home from "./component/home/Home";
import closed from "./assets/images.jpeg";
import logo from "./assets/kk.jpeg";
import React, { useContext, useState, useEffect, createContext } from "react";
import { useLocation } from "react-router-dom";
import Login from "./component/login/Login";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainPage from "./component/mianPage/MainPage";
import Side from "./component/side/Side";
import MyTeam from "./component/my-team/MyTeam";
import ChangePassword from "./component/changePassword/ChangePassword";
import ChangePocket from "./component/change-pocket/ChangePocket";
import Transfer from "./component/transfer/Transfer";
import AddUser from "./component/add-user/AddUser";
import Products from "./component/products/Products";
import Transactions from "./component/transactions/Transactions";
import Account from "./component/account-data/Account";
import Footer from "./component/footer/Footer";
import Week from "./component/week/Week";
import GoogleTranslate from "./component/GoogleTranslate";
import "./index.css";
import "./all.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Activities from "./component/activities/Activities";

export const AppContext = createContext();

function App() {
  const [login, setLogin] = useState(false);
  const [transOpen, setTransOpen] = useState(false);
  const [token, setToken] = useState("");
  const [userName, setUserName] = useState("");
  const [balance, setBalance] = useState("");
  const [loader, setLoader] = useState(false);
  const [fail, setFail] = useState(false);
  const [scduc, setSuc] = useState(false);
  const [done, setDone] = useState(false);
  const [noBalance, setNoBalance] = useState(false);
  const [paid, setPaid] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  //  const [route, setRoute] = useState("https://api.max-syr.com/api");
  //  const [imgRoute, setImgRoute] = useState("https://api.max-syr.com/storage");
  const [route, setRoute] = useState("https://api.elnabd.online/api");
  const [imgRoute, setImgRoute] = useState("https://api.elnabd.online/storage");
  const [news, setNews] = useState([]);
  const [available, setAvailable] = useState(true);
  const location = useLocation();
  const marqueeNews = news.length ? [...news, ...news] : [];

  useEffect(() => {
    fetch(`${route}/checkSiteAvailability`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === 1) {
          setAvailable(true);
        } else if (data.status === 0) {
          setAvailable(false);
        }
      });
  }, []);
  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    if (!location.hash) {
      if (location.pathname === "/") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    }

    const id = location.hash.replace("#", "");
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (JSON.parse(sessionStorage.getItem("login"))) {
      setLogin(true);
    } else {
      setLogin(false);
    }

    setToken(sessionStorage.getItem("token"));
    setUserName(sessionStorage.getItem("userName"));
  }, [login]);

  const reload = () => {
    window.location.reload();
  };

  useEffect(() => {
    fetch(`${route}/news`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.data) {
          setNews(data.data);
        }
      });
  }, []);

  if (available) {
    return (
      <AppContext.Provider
        value={{
          imgRoute,
          route,
          setRoute,
          userName,
          setUserName,
          login,
          setLogin,
          token,
          setToken,
          loader,
          setLoader,
          transOpen,
          setTransOpen,
        }}
      >
        <div className="App">
          {/* {login ?<div onClick={reload} className='update'> تحديث</div> :null} */}
          <ToastContainer />
          {/* {loader ?    <div className="spin-cont"><div className="spinner">
  <div className="rect1"></div>
  <div className="rect2"></div>
  <div className="rect3"></div>
  <div className="rect4"></div>
  <div className="rect5"></div>
</div></div>:null} */}

          <Nav />
          {/* <div className='news'><div className='in-news'>
      {news.map((ne,index)=>{
        return(
          <div key={index}>
           --- {ne.new}
          </div>
        )
      })}
      </div></div> */}
          <div className="news">
            <div className="news-shell">
              <span className="news-label">آخر الأخبار</span>

              <div className="news-track">
                <div className="in-news">
                  {marqueeNews.map((ne, index) => (
                    <div className="news-item" key={`${index}-${ne.new}`}>
                      <span className="dot">●</span>
                      <span className="text">{ne.new}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div
            className={`fixed flex justify-center items-center bg-opacity-90 z-[1000] bg-[#000] w-full h-full top-0 right-0  ${
              transOpen ? "block" : "hidden"
            }`}
          >
            <div className="bg-[#fff] p-12 rounded-lg relative">
              <div
                onClick={() => setTransOpen(false)}
                className="h-10 w-10 border border-gray rounded-full text-gray flex items-center justify-center absolute top-4 right-4 cursor-pointer hover:bg-dark hover:text-[#fff] transition"
              >
                X
              </div>
              <GoogleTranslate />
            </div>
          </div>
          {/* <div className='in-App'> */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/main-page" element={<MainPage />} />
            <Route path="/my-team" element={<MyTeam />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/change-pocket" element={<ChangePocket />} />
            <Route path="/transfer" element={<Transfer />} />
            <Route path="/add-user" element={<AddUser />} />
            <Route path="/products" element={<Products />} />
            <Route path="/trans" element={<Transactions />} />
            <Route path="/account" element={<Account />} />
            <Route path="/week" element={<Week />} />
            <Route path="/activities" element={<Activities />} />
          </Routes>
          <Footer />
        </div>
      </AppContext.Provider>
    );
  } else {
    return (
      <div className="closed">
        <img src={logo} className="logo-to-close" />
        <img src={closed} className="close-img" />
      </div>
    );
  }
}

export default App;

// {login ?<Side /> :null}
// </div>

// {login ? <h1 className='my-name'>{sessionStorage.getItem("userName")} مرحبا</h1> :null}
